import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { BUTTON_COLOR_NEW_UI } from '../../utils/ColorPicker';

const StyledButton = styled(Button)(({custompadding}) => ({
  padding: custompadding || '4px 25px',
  width: '110px',
  borderRadius: '5px',
  color: '#FFFFFF',
  textTransform: 'none !important',
  marginRight: '20px',
  border: 'none',
  letterSpacing: 'normal',
  backgroundColor: BUTTON_COLOR_NEW_UI,
  '&:hover': {
    backgroundColor: BUTTON_COLOR_NEW_UI,
    border: 'none',
  },
}));

const StyledSaveButton = ({
  label,
  onClickFn,
  customWidth,
  customFontFam,
  disabled,
  custompadding
}) => {
  const userDomain = useSelector((state) => state?.selectedDomain?.userDomain) || '';

  const buttonStyles = {};

  if (customWidth) {
    buttonStyles.width = `${customWidth}px`;
  }

  if (customFontFam) {
    buttonStyles.fontFamily = customFontFam;
  }

  return (
    <StyledButton
      onClick={onClickFn}
      type='submit'
      variant='contained'
      disabled={disabled}
      custompadding={custompadding}
      className={userDomain && !customFontFam && `${userDomain}_semi_bold_font letter-spacing-custom`}
      style={buttonStyles}>
      {label}
    </StyledButton>
  );
};

export default StyledSaveButton;
